import styled from 'styled-components'

export const ContainerTabs = styled.div`
  display: flex;
`
